import React, { useContext, useEffect, useState } from 'react';
import { Button, Grid } from '@material-ui/core';
import { Input, LinearProgress } from '@mui/material';

import { fbmApi as api } from '../../../../api/fbm';
import { UserContext } from '../../../../contexts/UserContext';
import { Notifications } from '../../../../shared';

import { DeepDiveResults } from './deepDiveResults';

function ViewOrderDeepDive({ fbmOrderNum }) {
    const [deepDiveResults, setDeepDiveResults] = useState({});
    const [notification, setNotification] = useState({ text: '', level: '' });
    const { fbmAccount } = useContext(UserContext);
    const [isIngesting, setIsIngesting] = useState(false);
    const [searchTerm, setSearchTerm] = useState(fbmOrderNum);
    const [searchLoading, setSearchLoading] = useState(false);

    // Load the page
    const loadData = async (id) => {
        setSearchLoading(true);
        const response = await api.getOrderDetails(id, fbmAccount.fbmAccountName);
        if (response.status === false) {
            setSearchLoading(false);
            setNotification({ text: `Error retrieving order ${response.msg}`, level: 'error' });
            return;
        }

        setDeepDiveResults(response.data.data);
        setSearchLoading(false);
        setNotification({ text: 'Success', level: 'success' });
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            loadData(searchTerm);
        }
    };

    useEffect(() => {
        if (searchTerm) {
            loadData(fbmOrderNum);
        }
    }, [fbmOrderNum]);

    return (
        <div>
            <h1>{fbmAccount.companyName} - Order Deep Dive</h1>
            <Notifications options={notification} />
            {!!fbmAccount.id && (
                <div>
                    <Grid container>
                        {Object.keys(deepDiveResults).length > 0 && (
                            <Grid item xs={4}>
                                <Button
                                    id="MarkShippedButton"
                                    onClick={async () => {
                                        const response = await api.markOrderShipped(
                                            deepDiveResults.shipmentID,
                                            fbmAccount.fbmAccountName,
                                        );
                                        if (response.status === false) {
                                            setNotification({
                                                text: `Error marking shipped ${response.msg}`,
                                                level: 'error',
                                            });
                                            return;
                                        }

                                        setNotification({ text: 'Success', level: 'success' });
                                    }}
                                >
                                    Mark Order Shipped
                                </Button>
                            </Grid>
                        )}
                        {Object.keys(deepDiveResults).length > 0 && (
                            <Grid item xs={4}>
                                <Button
                                    id="IngestButton"
                                    disabled={isIngesting || fbmAccount.fbmAccountName === 'goodhillfarms'}
                                    onClick={async () => {
                                        setIsIngesting(true);
                                        const response = await api.ingestSingleOrder(
                                            deepDiveResults.orderNum,
                                            fbmAccount.fbmAccountName,
                                        );
                                        setIsIngesting(false);
                                        if (response.status === false) {
                                            setNotification({
                                                text: `Unable to ingest ${response.msg}`,
                                                level: 'error',
                                            });
                                            return;
                                        }

                                        setNotification({ text: 'Success', level: 'success' });
                                    }}
                                >
                                    Ingest
                                </Button>
                            </Grid>
                        )}
                        <Grid item xs={12} className="flex items-center justify-center gap-2 !mt-[40px]">
                            <Input
                                value={searchTerm}
                                onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                }}
                                onKeyDown={handleKeyDown}
                                className="w-[450px]"
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    loadData(searchTerm);
                                }}
                            >
                                Search
                            </Button>
                        </Grid>
                    </Grid>
                    <br />
                    <br />
                    {searchLoading && <LinearProgress />}
                    {Object.keys(deepDiveResults).length > 0 && (
                        <DeepDiveResults companyName={fbmAccount.companyName} deepDiveResults={deepDiveResults} />
                    )}
                </div>
            )}
        </div>
    );
}

export { ViewOrderDeepDive };
